import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../component/ModalBasic';
import TextInput from '../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import moment from 'moment';


export const StockAdjustmentTable = (props) => {
    const itemColdefs = [
        {
            field: "creditStock",
            headerName: "Credit Stock",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
        },
        {
            field: "debitStock",
            headerName: "Debit Stock",
            minWidth: window.innerWidth * 0.08,
            flex: 1,
            filter: true,
        },
        {
            field: "date",
            headerName: "Date",
            minWidth: window.innerWidth * 0.1,
            flex: 1.5,
            filter: true,
            valueFormatter: (params) => {
                if (!params.value) return "";
                return moment(params.value).format("DD-MM-YYYY");
            }
        },
        {
            field: "itemRate",
            headerName: "Rate",
            minWidth: window.innerWidth * 0.1,
            flex: 1.5,
            filter: true,
        },
        {
            field: "reason",
            headerName: "Reason",
            minWidth: window.innerWidth * 0.1,
            flex: 1.5,
            filter: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: window.innerWidth * 0.1,
            flex: 1.5,
            filter: true,
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.12,
            flex: 1.5,
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => {
                if (!params.data.idStockAdjustmentItems || params.data.status !== 'Pending') return null;
                return (
                    <div className="flex items-center justify-center gap-2">
                        <button
                            onClick={() => props.handleUpdateStockAdjustmentStatus(params.data, 'Approve')}
                            className='update-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                            title="Approve"
                            disabled={props.roleId !== 1}
                        >
                            Approve
                        </button>
                        <button
                            onClick={() => props.handleUpdateStockAdjustmentStatus(params.data, 'Reject')}
                            className='edit-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                            title="Reject"
                            disabled={props.roleId !== 1}
                        >
                            Reject
                        </button>
                    </div>
                );
            },
        }
    ];
    return (
        <ModalBasic
            id="gatepass"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-inner grid grid-cols-6 items-start gap-2.5 mb-3'>
                    <div className='input-grp '>
                        <label>Adj No.</label>
                        <TextInput type='text'
                            id='adjNo' name='adjNo'
                            value={props.itemObject.adjNo}
                            handleChange={(event) => props.handleChange(event, 'adjNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Item Name</label>
                        <TextInput type='text'
                            id='s' name='itemName'
                            value={props.itemObject.itemName}
                            handleChange={(event) => props.handleChange(event, 'itemName')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing No</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item Category</label>
                        <TextInput type='text'
                            id='itemCategory' name='itemCategory'
                            value={props.itemObject.itemCategory}
                            handleChange={(event) => props.handleChange(event, 'itemCategory')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Currect Stock</label>
                        <TextInput type='text'
                            id='currentStock' name='currentStock'
                            value={props.itemObject.currentStock}
                            handleChange={(event) => props.handleChange(event, 'currentStock')}
                            disabled
                        />
                    </div>
                    <div className='btn-grp mt-5 flex gap-2.5'>
                        {props?.itemRowData?.length > 0 ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.printAdjustment()}>Print Adjustment</button>
                            </>
                            :
                            null
                        }
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold mt-5">Adjustment details</span>
                <div className='item-inner grid grid-cols-6 items-start gap-2.5 '>
                    <div className='input-grp '>
                        <label>Credit</label>
                        <TextInput type='number'
                            id='creditStock' name='creditStock'
                            value={props.adjustmentObject.creditStock}
                            handleChange={(event) => props.handleChange(event, 'creditStock')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Debit</label>
                        <TextInput type='number'
                            id='debitStock' name='debitStock'
                            value={props.adjustmentObject.debitStock}
                            handleChange={(event) => props.handleChange(event, 'debitStock')}
                        />
                    </div>
                    <div className='input-grp col-span-1'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.adjustmentObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                        />
                    </div>
                    <div className='input-grp col-span'>
                        <label>Rate</label>
                        <TextInput type='text'
                            id='itemRate' name='itemRate'
                            value={props.adjustmentObject.itemRate}
                            handleChange={(event) => props.handleChange(event, 'itemRate')}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Reason</label>
                        <TextInput type='text'
                            id='reason' name='reason'
                            value={props.adjustmentObject.reason}
                            handleChange={(event) => props.handleChange(event, 'reason')}
                        />
                    </div>

                    <div className='btn-grp flex gap-2.5'>
                        {props.adjustmentObject.keyId ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Update")}>Update</button>
                                <button className="delete-btn btns py-[10px] px-[20px] " onClick={() => props.delete(props.adjustmentObject.keyId)}>Delete</button>
                            </>
                            :
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }

                        <button className="edit-btn btns py-[10px] px-[20px] " onClick={() => props.clear()}>Clear</button>
                    </div>
                </div>
                <div className="process-table h-[30vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onRowDoubleClicked={props.handleCellClickItemList}
                            // onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}